import { MessageCircle, Instagram, Linkedin } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

const SOCIAL = {
  instagram: "https://www.instagram.com/carolstoffella",
  linkedin: "https://www.linkedin.com/in/c%CE%BBrol-stoff%CE%BEll%CE%BB%C2%AE-a6092360/",
  whatsapp: "https://wa.me/971558441468",
};

export default function FloatingSocial() {
  const { t } = useLang();
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      <a
        data-testid="floating-instagram"
        href={SOCIAL.instagram}
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
        className="w-11 h-11 flex items-center justify-center rounded-full bg-[#070E13] border border-[#C7A26C]/50 text-[#C7A26C] hover:bg-[#C7A26C] hover:text-[#070E13] hover:border-[#C7A26C] shadow-lg transition-all duration-300 hover:scale-110"
      >
        <Instagram size={18} strokeWidth={1.5} />
      </a>
      <a
        data-testid="floating-linkedin"
        href={SOCIAL.linkedin}
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn"
        className="w-11 h-11 flex items-center justify-center rounded-full bg-[#070E13] border border-[#C7A26C]/50 text-[#C7A26C] hover:bg-[#C7A26C] hover:text-[#070E13] hover:border-[#C7A26C] shadow-lg transition-all duration-300 hover:scale-110"
      >
        <Linkedin size={18} strokeWidth={1.5} />
      </a>
      <a
        data-testid="floating-whatsapp"
        href={SOCIAL.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label={t.common.whatsapp}
        className="group flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl transition-all duration-300 hover:scale-105"
      >
        <MessageCircle size={20} />
        <span className="text-xs tracking-widest uppercase font-medium hidden sm:inline">
          {t.common.whatsapp}
        </span>
      </a>
    </div>
  );
}
